module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isShow) ? _c('div', {
    staticClass: "right-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "right-header"
  }, [_vm._t("header", [_vm._v("\n        title\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "translate": ""
    }
  }, [_vm._v("clear")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content", [_c('el-form', {
    ref: "profileForm",
    staticClass: "profile-form",
    attrs: {
      "model": _vm.profileModel,
      "rules": _vm.rules
    }
  }, _vm._l((_vm.formItems), function(val, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "label": val.label,
        "labelWidth": val.labelWidth
      }
    }, _vm._l((val.childs), function(item, key) {
      return _c('el-col', {
        key: key,
        class: item.class,
        attrs: {
          "span": item.col
        }
      }, [_c('el-form-item', {
        attrs: {
          "prop": item.key
        }
      }, [(item.type === 'uploader') ? _c('el-upload', {
        staticClass: "uploader-wrapper",
        attrs: {
          "action": item.option.action,
          "show-file-list": false,
          "data": item.option.data,
          "before-upload": item.option.onBeforeUpload,
          "on-success": item.option.onSuccess,
          "on-error": item.option.onFail,
          "on-progress": item.option.onProgress,
          "on-change": item.option.onChange,
          "multiple": false
        }
      }, [(_vm.profileModel[item.key]) ? _c('img', {
        staticClass: "avatar",
        attrs: {
          "src": _vm.profileModel[item.key]
        }
      }) : _c('i', {
        staticClass: "el-icon-upload avatar-uploader-icon"
      }), _vm._v(" "), _c('div', [_vm._v("上传新头像")])]) : (item.type === 'select') ? _c('el-select', {
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, _vm._l((item.options), function(item, index) {
        return _c('el-option', {
          key: index,
          staticClass: "sns-item",
          attrs: {
            "label": item.text,
            "value": item.key
          }
        }, [(item.icon) ? _c('span', {
          staticClass: "pull-left"
        }, [_c('i', {
          class: item.icon
        })]) : _vm._e(), _vm._v(" "), (item.logo) ? _c('span', {
          staticClass: "pull-left"
        }, [_c('img', {
          staticClass: "sns-logo",
          attrs: {
            "src": item.logo,
            "border": "0"
          }
        })]) : _vm._e(), _vm._v(" "), (item.icon) ? _c('span', [_c('i', {
          staticClass: "material-icons pull-left"
        }, [_vm._v(_vm._s(item.icon))])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])])
      })) : (item.type === 'level') ? _c('el-select', {
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, _vm._l((item.options), function(perItem, index) {
        return _c('el-option', {
          key: index,
          attrs: {
            "label": perItem.label,
            "value": perItem.key
          }
        }, [_c('el-rate', {
          attrs: {
            "disabled": "",
            "text-template": perItem.label,
            "show-text": true
          },
          model: {
            value: (perItem.val),
            callback: function($$v) {
              perItem.val = $$v
            },
            expression: "perItem.val"
          }
        })], 1)
      })) : (item.type === 'radio') ? _c('el-radio-group', {
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, _vm._l((item.options), function(option, key) {
        return _c('el-radio', {
          key: key,
          attrs: {
            "label": option.label
          }
        }, [_vm._v(_vm._s(option.text))])
      })) : (item.type === 'datePicker') ? _c('el-date-picker', {
        attrs: {
          "type": item.pickerType,
          "placeholder": item.placeholder
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }) : (item.type === 'separation') ? _c('span', {
        staticClass: "line"
      }, [_vm._v(" " + _vm._s(item.text) + " ")]) : (item.type === 'tips') ? _c('span', {
        staticClass: "line",
        staticStyle: {
          "display": "block",
          "margin-left": "130px",
          "margin-top": "-12px",
          "color": "#999",
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.text))]) : (item.type === 'check') ? _c('el-checkbox', {
        on: {
          "change": function($event) {
            item.checkFun(_vm.profileModel[item.key])
          }
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, [_vm._v(_vm._s(item.label))]) : (item.type === 'textarea') ? _c('el-input', {
        staticClass: "right-panel-textarea",
        attrs: {
          "type": "textarea",
          "autosize": item.options.autosize,
          "resize": item.options.resize
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }) : _c('el-input', {
        attrs: {
          "disabled": item.disabled
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, (typeof $$v === 'string' ? $$v.trim() : $$v))
          },
          expression: "profileModel[item.key]"
        }
      })], 1)], 1)
    }))
  }))])], 2), _vm._v(" "), (!_vm.hideFooter) ? _c('div', {
    staticClass: "footer"
  }, [_vm._t("footer", [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('profileForm')
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)])], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e51789"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/right-panel.vue
// module id = 593
// module chunks = 4 5 6